export default __webpack_public_path__ + "static/media/parth-min.2a71cda1.png";